
<template>
  <el-dialog
    custom-class="location-map-dialog form-dialog"
    title="选择地址（点击地图选中地址）"
    top="5vh"
    width="70vw"
    v-model="mapDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
  >
    <div class="map-content">
      <div class="search-box">
        <el-autocomplete
          class="address-search"
          v-model="addressKey"
          value-key="fullName"
          placeholder="输入地名搜索"
          :fetch-suggestions="handleSearchMap"
          :trigger-on-focus="false"
          @select="handleSelectAddr"
        ></el-autocomplete>
      </div>
      <div id="map-container"></div>
    </div>
    <template #footer>
      <el-button class="submit-btn" @click="confirmLocation">确 认</el-button>
      <el-button class="cancel-btn" @click="closeDialog">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

/**
 * @param {Boolean} visible 是否可见
 * @param {String, Number} lng 经度
 * @param {String, Number} lat 纬度
 * @param {String} lnglat 以逗号分隔的经纬度
 * 
 * @event close 关闭弹框事件
 * @event confirm 确认事件，返回参数 { lng, lat, address }
 */

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 默认地址深圳南山智谷F座
    lng: {
      type: [String, Number],
      default: 113.959779,
    },
    lat: {
      type: [String, Number],
      default: 22.576307,
    },
    lnglat: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mapDialog: false,
      scale: 15,
      addressKey: '',

      curLat: 0,
      curLng: 0,
      address: ''
    }
  },
  emits: ['confirm','close'],
  computed: {
    ...mapState({
      userInfo: (state) => state.common.userInfo,
    }),
  },
  watch: {
    visible(val) {
      this.mapDialog = val
      if (val) {
        this.addressKey = ''
        this.curLng = this.lng
        this.curLat = this.lat
        if (this.lnglat && typeof this.lnglat === 'string') {
          this.curLng = this.lnglat.split(',')[0]
          this.curLat = this.lnglat.split(',')[1]
        }
        this.$nextTick(() => {
          this.initMap()
        })
      }
    },
  },
  methods: {
    // 地图初始化
    initMap() {
      let point = {
        lng: !this.curLng ? this.userInfo.xPoint : this.curLng,
        lat: !this.curLat ? this.userInfo.yPoint : this.curLat,
      }

      let map = new BMapGL.Map('map-container')
      let poi = new BMapGL.Point(point.lng, point.lat)
      
      if (this.curLng && this.curLat) {
        map.centerAndZoom(poi, 19)
        let marker = new BMapGL.Marker(poi)
        map.addOverlay(marker)
      } else {
        map.centerAndZoom(poi, this.scale)
      }

      map.enableScrollWheelZoom(true)
      map.addEventListener('click', this.addMarker)

      this.map = map
    },
    // 处理地址搜索
    handleSearchMap(queryString, cb) {
      if (!queryString) cb([])

      window.getBMapAddressSuggestion = (res) => {
        let temp = res.result || []
        temp.forEach(item => {
          item.fullName = `${item.name}（${item.address}）`
        })
        cb(temp)
      }

      let url = `${window.location.protocol}//api.map.baidu.com/place/v2/suggestion?query=${this.addressKey}&output=json&region=全国&ak=HYdW2FpLipnQNl9RFp73C4h5lzlj8WNC&callback=getBMapAddressSuggestion`
      jQuery.getScript(url)
    },
    // 处理地址选中
    handleSelectAddr(item) {
      this.curLng = item.location.lng
      this.curLat = item.location.lat
      this.address = item.address

      let point = new BMapGL.Point(item.location.lng, item.location.lat)
      this.map.centerAndZoom(point, 19)
      let marker = new BMapGL.Marker(point)
      this.map.clearOverlays()
      this.map.addOverlay(marker)
    },
    // 选中点位，添加覆盖物
    addMarker(e) {
      this.curLng = e.latlng.lng
      this.curLat = e.latlng.lat
      this.address = ''
      this.addressKey = ''

      let marker = new BMapGL.Marker(new BMapGL.Point(this.curLng, this.curLat))
      this.map.clearOverlays()
      this.map.addOverlay(marker)

      
    },
    // 确认地址
    confirmLocation() {
      let geoc = new BMapGL.Geocoder();
      let _this = this

      let pt = new BMapGL.Point(this.curLng, this.curLat)
      geoc.getLocation(pt, (rs) => {
        let addComp = rs.addressComponents;
        //console.log(rs, addComp.province + " " + addComp.city + " " + addComp.district + " " + addComp.street + " " + addComp.streetNumber);
        this.address = rs.address
        this.$emit('confirm', { lng: this.curLng, lat: this.curLat, address: this.address, res:rs })
        this.closeDialog()
      });
      
    },
    // 处理关闭
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.location-map-dialog {
  /deep/ .el-dialog {
    background: white !important;
  }
  /deep/ .el-dialog__body {
    padding: 15px 20px;
    background-color: unset !important;
  }
  .dialog-footer {
    text-align: center;
  }
  .el-button{
    margin: 15px;
  }
}
.map-content {
  width: 100%;
  height: 70vh;
  .search-box {
    margin-bottom: 10px;
    .address-search {
      width: 600px;
    }
  }
  #map-container {
    overflow: hidden;
    width: 100%;
    height: calc(~'100% - 42px');
    margin: 0;
    border: 1px solid #dcdfe6;
  }
}
</style>

<style lang="less">
.el-autocomplete-suggestion__wrap {
  background: unset !important;
}
.el-autocomplete-suggestion__wrap li:hover {
  background-color: unset !important;
}
</style>